import React from "react";
import CTA from "./CTA.jsx";
import "./header.css";
import ME from "../../assets/about_img.jpg";
import HeaderSocials from "./HeaderSocials.jsx";

const Header = () => {
  return (
    <header>
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1>Anna Druzhinina</h1>
        <h5 className="text-light">Full Stack Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="" />
        </div>
        <a href="#contact" className="scroll_down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
